<script>
import axios from 'axios';
import router from '@/router';
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import progressContainer from './progressContainer.vue';

import { required, maxLength } from 'vuelidate/lib/validators';

export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { /*logoutButton ,*/ Header, Footer, progressContainer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userData: JSON.parse(localStorage.getItem('web_user')),
			backToOverview: false,
			addAdditionalDetailsForm: {
				adult_teen_challenge: '',
				hobbies: '',
				skills: '',
				language: '',
				education: '',
				occupation: '',
				employment_experience: '',
				user_type_id: '',
				hear_about: '',
				additional_info: '',
				working_city: '',
			},
			typeSubmit: false,
		};
	},
	validations: {
		addAdditionalDetailsForm: {
			adult_teen_challenge: { required, maxLength: maxLength(2500) },
			hobbies: { required },
			// skills: { required},
			occupation: { required },
			hear_about: { required },
		},
	},
	mounted() {
		this.getAdditionalDetails();
		this.getSubmitFormStats();
	},
	methods: {
		skipToReview() {
			router.push({ name: 'review-application' });
		},

		addAdditionalDetails() {
			this.typeSubmit = true;
			this.$v.$touch();
			if (!this.$v.$invalid) {
				var userData = JSON.parse(localStorage.getItem('web_user'));
				var config = {
					headers: { Authorization: 'Bearer ' + userData.token },
				};
				if (userData.token) {
					this.addAdditionalDetailsForm.user_type_id = userData['user_type_id'];
					this.addAdditionalDetailsForm.user_id = userData['id'];
					axios
						.post('user/additional_details', this.addAdditionalDetailsForm, config)
						.then((res) => {
							if (res.status == 200) {
								if (userData.user_type_id === 4 && !userData.is_mentor) {
									router.push({ name: 'opportunities' });
								} else {
									router.push({ name: 'references' });
								}
							}
						})
						.catch((err) => {
							if (err.response) {
								console.log(err.response.data.error.message);
							}
						});
				}
			}
		},
		// Getting Current User Additional Details
		getAdditionalDetails() {
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData.token },
			};
			if (userData.token) {
				axios
					.get('user/additional_details/' + userData['id'] + '?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						if (res.status == 200) {
							this.addAdditionalDetailsForm = res.data.response;
							console.log(this.addAdditionalDetailsForm);
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
						}
					});
			}
		},
		faith() {
			router.push({ name: 'faith' });
		},
		employment() {
			router.push({ name: 'employment' });
		},
		contactt() {
			router.push({ name: 'contact' });
		},
		// Getting Current User Forms States
		getSubmitFormStats() {
			let formCompleted = true;
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData['token'] },
			};
			if (userData.token) {
				axios
					.get('user/registration/submitted-forms?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						// Mentor
						if (userData['user_type_id'] == 3) {
							if (res.data.response.additional_details === false) {
								formCompleted = false;
							}
							if (res.data.response.background === false) {
								formCompleted = false;
							}
							if (res.data.response.faith === false) {
								formCompleted = false;
							}
							if (res.data.response.personal_info === false) {
								formCompleted = false;
							}
							if (res.data.response.question === false) {
								formCompleted = false;
							}
							if (res.data.response.reference === false) {
								formCompleted = false;
							}
						} else {
							if (userData.is_mentor) {
								// Mentor/Volunteer
								if (res.data.response.additional_details === false) {
									formCompleted = false;
								}
								if (res.data.response.background === false) {
									formCompleted = false;
								}
								if (res.data.response.faith === false) {
									formCompleted = false;
								}
								if (res.data.response.personal_info === false) {
									formCompleted = false;
								}
								if (res.data.response.question === false) {
									formCompleted = false;
								}
								if (res.data.response.reference === false) {
									formCompleted = false;
								}
								if (res.data.response.opportunity === false) {
									formCompleted = false;
								}
							} else {
								// Volunteer
								if (res.data.response.additional_details === false) {
									formCompleted = false;
								}
								if (res.data.response.faith === false) {
									formCompleted = false;
								}
								if (res.data.response.opportunity === false) {
									formCompleted = false;
								}
								if (res.data.response.personal_info === false) {
									formCompleted = false;
								}
								if (res.data.response.question === false) {
									formCompleted = false;
								}
							}
						}

						if (!formCompleted) {
							this.backToOverview = false;
						} else {
							this.backToOverview = true;
						}
					})
					.catch((err) => {
						if (err.response) {
							console.log(err.response.data.error.message);
						}
					});
			}
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row mx-0">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title" v-if="userData.is_mentor">Mentor / Volunteer Details</h3>
						<h3 class="title" v-else>{{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }} Application</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a @click="contactt" href="javascript:">Contact Us</a></p>
						<!--              <logout-button></logout-button>-->
					</div>
				</div>
			</div>
		</div>
		<div id="create-account">
			<div class="container">
				<div class="row mx-0 justify-content-center">
					<div class="col-12">
						<progressContainer :userData="userData" :active="'additional-details'" />
					</div>
				</div>
				<form class="custom-form">
					<div class="row mx-0">
						<div class="col-12 mb-5">
							<h3 class="main-title">Interests, Skills, Involvement</h3>
							<p class="text-center text-muted" style="text-transform: initial">Your answers may help us pair you with a client.</p>
						</div>
					</div>
					<div class="row mx-0">
						<div class="col-12 mb-5">
							<label>When and how did you first hear about MnTC?*</label>
							<input v-model="addAdditionalDetailsForm.hear_about" type="text" placeholder="Write here" class="mt-2 form-control" :class="{ 'is-invalid': typeSubmit && $v.addAdditionalDetailsForm.hear_about.$error }" />

							<div v-if="typeSubmit && $v.addAdditionalDetailsForm.hear_about.$error" class="invalid-feedback">
								<span v-if="!$v.addAdditionalDetailsForm.hear_about.required">This field is required.</span>
							</div>
						</div>

						<div class="col-12 mb-5">
							<label>Why do you think you would make a good {{ userData['user_type_id'] == 4 ? 'volunteer' : 'mentor' }} at MnTC?*</label>
							<input v-model="addAdditionalDetailsForm.adult_teen_challenge" type="text" placeholder="Write here" class="mt-2 form-control" :class="{ 'is-invalid': typeSubmit && $v.addAdditionalDetailsForm.adult_teen_challenge.$error }" />
							<div v-if="typeSubmit && $v.addAdditionalDetailsForm.adult_teen_challenge.$error" class="invalid-feedback">
								<span v-if="!$v.addAdditionalDetailsForm.adult_teen_challenge.required">This field is required.</span>
								<span v-if="!$v.addAdditionalDetailsForm.adult_teen_challenge.maxLength">This value is too long. It should have 500 words or less</span>
							</div>
						</div>
						<div class="col-12 mb-5">
							<label>What are your hobbies, interests and passions?*</label>
							<input v-model="addAdditionalDetailsForm.hobbies" type="text" placeholder="Write here" class="mt-2 form-control" :class="{ 'is-invalid': typeSubmit && $v.addAdditionalDetailsForm.hobbies.$error }" />
							<div v-if="typeSubmit && $v.addAdditionalDetailsForm.hobbies.$error" class="invalid-feedback">
								<span v-if="!$v.addAdditionalDetailsForm.hobbies.required">This field is required.</span>
							</div>
						</div>
						<div class="col-12 mb-5">
							<label>Do you have any trade skills?</label>
							<input v-model="addAdditionalDetailsForm.skills" type="text" placeholder="Write here" class="form-control mt-2" />
							<!-- <div v-if="typeSubmit && $v.addAdditionalDetailsForm.skills.$error" class="invalid-feedback">
                <span v-if="!$v.addAdditionalDetailsForm.skills.required">This field is required.</span>
              </div> -->
						</div>
						<div class="col-12 mb-5">
							<label>Please list any languages that you speak other than English:</label>
							<input v-model="addAdditionalDetailsForm.language" type="text" placeholder="Write here" class="form-control mt-2" />
						</div>
						<div class="col-12 mb-5">
							<label>What is your educational background? (degrees, field(s) of study, etc.) </label>
							<input v-model="addAdditionalDetailsForm.education" type="text" placeholder="Write here" class="form-control mt-2" />
						</div>
						<div class="col-12 mb-5">
							<label>What is your current occupation?*</label>
							<input v-model="addAdditionalDetailsForm.occupation" type="text" placeholder="Write here" class="form-control mt-2" :class="{ 'is-invalid': typeSubmit && $v.addAdditionalDetailsForm.occupation.$error }" />
							<div v-if="typeSubmit && $v.addAdditionalDetailsForm.occupation.$error" class="invalid-feedback">
								<span v-if="!$v.addAdditionalDetailsForm.occupation.required">This field is required.</span>
							</div>
						</div>
						<div class="col-12 mb-5">
							<label>Where are you currently employed?</label>
							<input v-model="addAdditionalDetailsForm.employment_experience" type="text" placeholder="Write here" class="form-control mt-2" />
						</div>

						<div class="col-12 mb-5">
							<label>What is the city and state where you work?</label>
							<input v-model="addAdditionalDetailsForm.working_city" type="text" placeholder="Write here" class="form-control mt-2" />
						</div>

						<div class="col-12 mb-5">
							<label>Is there any additional information you would like to share? (ie: previous employment, skills, certificates, credentials, etc.)</label>
							<input v-model="addAdditionalDetailsForm.additional_info" type="text" placeholder="Write here" class="form-control mt-2" />
						</div>
					</div>
					<div class="row mx-0">
						<div class="mb-2 col-12 d-flex flex-column flex-md-row justify-content-start justify-content-md-end align-items-stretch align-items-md-start" v-if="backToOverview">
							<b-button type="button" @click="skipToReview" variant="custom">
								<i class="font-size-20 me-2 bx bxs-right-arrow-circle"></i>
								Skip To Review
							</b-button>
						</div>

						<div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-if="userData['user_type_id'] === 4 && !userData.is_mentor">
							<b-button type="button" @click="faith" variant="custom"><i class="font-size-20 ms-2 bx bxs-left-arrow-circle"></i> Faith</b-button>
							<b-button type="button" @click="addAdditionalDetails" variant="custom">Select Opportunities <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
						</div>
						<div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-else>
							<b-button type="button" @click="faith" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Faith Journey</b-button>
							<b-button type="button" @click="addAdditionalDetails" variant="custom">Character Reference <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
						</div>
						<!-- <div class="mb-5 col-12 d-flex flex-column-reverse flex-md-row justify-content-start justify-content-md-between align-items-stretch align-items-md-start" v-if="userData.is_mentor">
                <b-button type="button" @click="employment" variant="custom"><i class="font-size-20 me-2 bx bxs-left-arrow-circle"></i> Employment</b-button>
                <b-button type="button" @click="addAdditionalDetails" variant="custom">Select Opportunities <i class="font-size-20 ms-2 bx bxs-right-arrow-circle"></i></b-button>
              </div> -->
					</div>
				</form>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
